var e = /* @__PURE__ */ ((r) => (r.Base = "iress-u-stack", r.Gutter = "iress--gutter", r))(e || {});
export {
  e as StackCssClass
};
